<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="enter-license-plate-header"></app-header>
<div class="base-content-container" data-testid="enter-license-plate-container">
  <div class="headline3" data-testid="enter-license-plate-title">{{locale.currentTranslation.enterLicensePlate1}}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="license-plate-form">
    <div>
      <div style="width: 100%;">
        <app-text-input
          [(value)]="licensePlate"
          [placeholder]="locale.currentTranslation.licensePlateInputPlaceholder"
          [showError]="showError"
          [required]="true"
          data-testid="input-license-plate"
          [attr.aria-label]="locale.currentTranslation.licensePlateInputPlaceholder"
        ></app-text-input>
      </div>
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{locale.currentTranslation.enterValidLicensePlate}}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="enter-license-plate-footer"></app-footer>
